<template>
  <div class="channel-box">
    <!-- 特殊活动标题显示 -->
    <div v-if="specialTitle" class="special-title">
      {{ specialTitle }}
    </div>
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      fixed="true"
      @click-left="onClickLeft"
    />
    <!-- <van-tabs sticky @change="changeFn">
      <van-tab v-for="item in brotherCategory" :key="item.id" :title="item.name" >
        <h4>{{ item.name }}</h4>
        <p>{{ front_desc }}</p> -->
        <!-- 产品列表 -->
        <!-- <Products :style="{marginTop: activityId === 16 ? '0%' : '15%'}" :goodsList="brotherCategory" /> -->

      <!-- </van-tab>
    </van-tabs> -->
    <div style="margin-top: 15%;">
       <div
      class="prod-items"
      v-for="item in brotherCategory"
      :key="item.id"
      @click="gotodetail(item.prodId)"
    >
      <div class="hot-imagecont">
        <img :src="item.pic" class="hotsaleimg" />
      </div>
      <div class="hot-span">
        <div class="hotprod-span">{{ item.prodName }}</div>
        <div class="prod-info" v-if="sts == 6">
          {{ item.prodCommNumber }}评价 {{ item.positiveRating }}%好评
        </div>
        <div
          class="'prod-span-info'"
        >
          <div class="price">
            <img v-if="currentActivityId == 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/>
            <span v-if="currentActivityId != 13" class="symbol">￥</span>
            <span class="big-num">{{ item.price }}</span>
            <span class="original-price" v-if="item.oriPrice && currentActivityId != 16">
              <span class="symbol">原价：</span>
              <span class="ori-num">{{ item.oriPrice }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载中提示 -->
    <div v-if="loading" class="loading-wrapper">
      <img src="https://img.zhujiaxian.com/2025/05/21f52dbb86f247098f3b3add676a775b.gif" alt="加载中" class="loading-gif">
    </div>
      </div>
     
  </div>
</template>

<script>
import { GetCateGoryData, GetCateGoryList,GetFenleiDataApi } from "@/https/http";
import Products from "@/components/Products";
import store from '@/store/index.js';

export default {
  name: "channel",
  data() {
    return {
      title:'',
      id_: "0", // 当前类别的id
      page: 1, // 当前页数
      size: 1000, //每页显示条数
      brotherCategory: [], // 分类数组
      goodsList: [], //当前类别对应的商品列表
      front_desc: "",
      specialTitle: '', // 特殊活动标题
      activityId: null, // 当前活动ID
      sts: null, // 状态
          //提交的数据
      result:{
        size: 10, // 修改为每页10条，便于测试触底加载
        sort: 0,
        pages:1,
        current:1,
        orderBy:0,
      },
      loading: false, // 加载状态
    };
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    // 组件销毁前移除监听器
    window.removeEventListener('scroll', this.handleScroll);
  },

  created() {
    this.id_ = this.$route.query.id;
    this.prodName = this.$route.query.title;
    this.getCategoryData();  //获取所有分类数据
    //this.getCategoryListData();  //获取当前类别对应的产品数组
    if(this.id_ == 284){
      this.title = '粮油副食'
    }else if(this.id_ == 352){
      this.title = '休闲食品'
    }else if(this.id_ == 550){
      this.title = '南北干货'
    }else if(this.id_ == 406){
      this.title = '生鲜果蔬'
    }else if(this.id_ == 490){
      this.title = '家居生活'
    }else if(this.id_ == 575){
      this.title = '奶制品'
    }else if(this.id_ == 129){
      this.title = '酒水茶饮'
    }else if(this.id_ == 545){
      this.title = '套餐精选' 
    }
    if(this.id_ == 45){
      this.title = '广西馆'
    }else if(this.id_ == 44){
      this.title = '广东馆'
    }else if(this.id_ == 65){
      this.title = '新疆馆'
    }else if(this.id_ == 54){
      this.title = '西藏馆'
    }




       if(this.id_ == 4760){
      this.title = '粮油副食'
    }else if(this.id_ == 4762){
      this.title = '零食茶饮'
    }else if(this.id_ == 4761){
      this.title = '南北干货'
    }else if(this.id_ == 4763){
      this.title = '生鲜水果'
    }else if(this.id_ == 4764){
      this.title = '个护日化'
    }else if(this.id_ == 4765){
      this.title = '套餐精选' 
    }

     if(this.id_ == 4744){
      this.title = '大米'
    }else if(this.id_ == 4745){
      this.title = '食用油'
    }else if(this.id_ == 4746){
      this.title = '杂粮'
    }else if(this.id_ == 4747){
      this.title = '面/粉'
    }else if(this.id_ == 4748){
      this.title = '南北干货'
    }else if(this.id_ == 4749){
      this.title = '牛奶饮品'
    }else if(this.id_ == 4750){
      this.title = '生鲜冻品'
    }else if(this.id_ == 4751){
      this.title = '休闲食品' 
    }else if(this.id_ == 4752){
      this.title = '冲调滋补' 
    }else if(this.id_ == 4753){
      this.title = '日化百货' 
    }

    if(this.prodName == '圳品'){
      this.title = '圳品'
    }
  }, 
  methods: {
    // // 获取当前活动ID
    // get currentActivityId() {
    //   return store.getters.getActivityId;
    // },

    // 触底加载处理
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当距离底部小于 50px 且不在加载状态且还有更多页面时触发加载
      if (documentHeight - (scrollTop + windowHeight) < 50 && !this.loading && this.result.current < this.result.pages) {
        this.loading = true;
        console.log("触发加载更多");
        this.result.current++;
        this.getCategoryData();
      }
    },

    //获取所有分类数据
 gotodetail(id_) {
      this.$router.push({ path: "/productDetail", query: { id: id_ } });
    },
    getCategoryData() {
          var ths = this;
          // 创建基础数据对象
          let data = {
            current: ths.result.current,
            size: ths.result.size  == undefined?'':this.result.size,
            sort: ths.result.sort  == undefined?'':this.result.sort,
            orderBy: ths.result.orderBy,
            pages : ths.result.pages == undefined ? '' : this.result.pages,
            // attribute:ths.data.prodState == 0 ?2:1,
            prodName: ths.prodName == undefined ? '' : this.prodName,
          }
          if(this.id_ == 44){
          
            data.provinceId = ths.id_ == undefined?'':this.id_;
          }else if(this.id_ == 65){
            data.provinceId = ths.id_ == undefined?'':this.id_;
          }else if(this.id_ == 45){
            data.provinceId = ths.id_ == undefined?'':this.id_;
          }else if(this.id_ == 54){
            data.provinceId = ths.id_ == undefined?'':this.id_;
          }else{
            data.firstCategoryId = ths.id_ == undefined?'':this.id_;
          }
          
      GetFenleiDataApi(data).then((res) => {
        console.log(res,'res，GetFenleiDataApi');
        
        // 支持分页加载：第一页替换，其他页追加
        if (res.data.current == 1) {
          ths.brotherCategory = res.data.records;
        } else {
          ths.brotherCategory = ths.brotherCategory.concat(res.data.records);
        }
        // 更新总页数
        ths.result.pages = res.data.pages;
        // 加载完成，重置loading状态
        ths.loading = false;
      }).catch(err => {
        console.error('加载数据失败:', err);
        ths.loading = false;  // 出错时也要重置 loading 状态
      });
    },

    //获取当前类别对应的产品数组
    getCategoryListData() {
      GetCateGoryList({
        categoryId: this.id_,
        page: this.page,
        size: this.size,
      }).then((res) => {
        console.log(33, res);
        if (res.errno == 0) {
          this.goodsList = res.data.goodsList;
        }
      });
    },

    // / 切换分类
    changeFn(title, name) {
      // title 下标
      // name: 分类标题
      this.brotherCategory.forEach((item) => {
        if (item.name == name) {
          this.id_ = item.id;
        }
      });
      this.getCategoryListData();
      this.getCategoryData();
    },
    
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  
  components: {
    Products,
  },
};
</script>

<style lang="less" scoped>
.channel-box {
  font-size: 16px;
  line-height: 40px;
  p {
    color: #666;
  }
}
.special-title {
  background-color: #fff;
  padding: 10px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.prod-items {
  width: 172.5px;
  display: inline-block;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 5px;

}

.hot-imagecont .hotsaleimg {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.hot-span .hotprod-span {
  height: 38px;
  line-height: 19px;
  font-size: 14px;
  display: -webkit-box;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #000;
}

.prod-items .hot-imagecont {
  text-align: center;
  font-size: 0;
  width: 152px;
  height: 152px;
}

.prod-items .hot-span {
  margin-top: 10px;
}

.prod-items .hot-span .prod-info {
  font-size: 10px;
  color: #777;
  margin-top: 4px;
  margin-left: 8px;
}

.prod-items .hot-span .prod-span-info {
  position: relative;
  height: 20px;
  line-height: 20px;
  font-family: Arial;
  margin-top: 10px;
}
.collection-row {
  display: flex;
  justify-content: space-between;
}

.price {
  color: #e43130;
}
.deadline-price{
  font-size: 11px;
  margin-right:2.5px;
}

.basket-img{
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  bottom: 3px;
  padding: 4px;
}
.symbol {
    font-size: 12px;
}
.big-num {
    font-size: 16px;
}
.original-price {
     margin-left: 8px;
     color: #999;
}
.original-price .symbol, .original-price .ori-num {
     font-size: 11px;
     text-decoration: line-through;
}

/* 加载中样式 */
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.loading-gif {
  width: 50px;
  height: 50px;
  display: inline-block;
}
</style>
